/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Preset_Manager_TitleInputs */



/**
* | output |
* | --- |
* | "Preset Manager" |
*
* @param {Preset_Manager_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const preset_manager_title = /** @type {((inputs?: Preset_Manager_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Preset_Manager_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Gestionnaire de préréglages")
	if (locale === "de") return /** @type {LocalizedString} */ ("Voreinstellungsmanager")
	if (locale === "it") return /** @type {LocalizedString} */ ("Gestore preimpostato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Менеджер предустановок")
	if (locale === "es") return /** @type {LocalizedString} */ ("Administrador de ajustes preestablecidos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预设管理器")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリセットマネージャー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रीसेट प्रबंधक")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Gerenciador de predefinições")
	return /** @type {LocalizedString} */ ("Preset Manager")
});